import React from 'react';
import { useAsset } from '../../../queries/ats/titles/hooks';
import { DetailsContextProvider } from '../details-context';
import { DataProviderChild } from './data-provider-child';
import { DetailsDataProviderProps } from './details-data-provider';

export function DefaultDetailsDataProvider({
  id,
  orderByProviderId,
  orderByServiceType,
  children,
  skeleton,
  fallback,
}: Omit<DetailsDataProviderProps, 'type'>) {
  const {
    data: asset,
    error,
    isLoading,
  } = useAsset({ id, orderByProviderId, orderByServiceType, useErrorBoundary: false });

  if (isLoading) {
    return skeleton;
  }

  if (error) {
    return fallback;
  }

  if (asset === undefined) {
    if (process.env.NODE_ENV !== 'production') {
      console.error(`No asset found for id: ${id}`);
    }

    return fallback;
  }

  return (
    <DetailsContextProvider asset={asset}>
      <DataProviderChild asset={asset}>{(args) => children(args)}</DataProviderChild>
    </DetailsContextProvider>
  );
}
